import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let token = localStorage.getItem("fmis_token");
export const setToken = (t) => {
  token = t;
  if (t) localStorage.setItem("fmis_token", t);
  else localStorage.removeItem("fmis_token");
};

api.interceptors.request.use((c) => {
  if (token) c.headers.Authorization = `Bearer ${token}`;
  return c;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    if (err.response?.status === 401 && !cfg._retry && !String(cfg.url).includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        const r = await refreshing;
        setToken(r.data.token);
        return api(cfg);
      } catch (e) {
        setToken(null);
        window.dispatchEvent(new Event("fmis-logout"));
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  if (!e?.response) return "No internet connection. Please try again when you are online.";
  const d = e.response.data?.detail;
  if (d == null) return "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d.message) return d.message;
  return String(d);
}

export function peso(c) {
  if (c === null || c === undefined) return "—";
  const n = Math.round(Number(c));
  const a = Math.abs(n);
  const whole = Math.floor(a / 100).toLocaleString("en-PH");
  return `${n < 0 ? "-" : ""}₱${whole}.${String(a % 100).padStart(2, "0")}`;
}

export function parseCents(v) {
  const s = String(v ?? "").replace(/[,₱\s]/g, "");
  if (!s) return 0;
  if (!/^\d+(\.\d{0,2})?$/.test(s)) return null;
  const [w, f = ""] = s.split(".");
  return parseInt(w, 10) * 100 + parseInt((f + "00").slice(0, 2), 10);
}

export const centsToInput = (c) => (c == null ? "" : `${Math.floor(c / 100)}.${String(c % 100).padStart(2, "0")}`);

export async function download(path, params, fallbackName) {
  const r = await api.get(path, { params, responseType: "blob" });
  const cd = r.headers["content-disposition"] || "";
  const m = cd.match(/filename="([^"]+)"/);
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = m ? m[1] : fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const uuid = () => (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);
